module.exports = __webpack_public_path__ + "static/img/value_2.1aa79a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/value_2.png
// module id = SUvA
// module chunks = 1